import { MaintenanceTaskInterface } from "../types";

export const filterOutMaintenanceTaskCreatedForOtherMaintenanceTaskProcessStep =
  (maintenanceTask: MaintenanceTaskInterface): boolean =>
    maintenanceTask.originalMaintenanceTaskProcessStepId == null;
